import { FC, MouseEvent, useEffect } from 'react';

import dayjs from 'dayjs';

import { useAnalytics } from '@hooks/useAnalytics';

import { openExternalUrl } from '@utilities/openExternalUrl';

import { AsyncImage } from '@components/layout/AsyncImg';

import kingOfDragWeeklyBannerImg from './king-of-drag-weekly-banner.jpg';

export const KingOfDragBanner: FC<{ context: string }> = ({ context }) => {
  const { track } = useAnalytics();

  const url =
    'https://revry.com?utm_source=gaggl&utm_medium=referral&utm_campaign=king_of_drag_pilot';

  useEffect(() => {
    track('King of Drag Banner Impression', {
      context,
    });
  }, []);

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    track('King of Drag Banner Clicked', {
      context,
    });
    openExternalUrl(url);
  };

  return (
    <div onClick={handleClick} role="button" style={{ position: 'relative' }}>
      <div
        className="py-1 px-2"
        style={{
          position: 'absolute',
          right: 0,
          top: '100%',
          fontSize: 8,
          opacity: 0.5,
        }}
      >
        Advertisement
      </div>
      <AsyncImage
        className="w-100 d-block"
        placeholder={<div className="w-100" style={{ aspectRatio: 16 / 4.5 }} />}
        src={kingOfDragWeeklyBannerImg}
      />
    </div>
  );
};
